import { Context } from "./context.js";
import { lusolve } from "mathjs";
import React, { useState, useEffect, useRef } from "react";
import * as RB from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { createSlice } from "@reduxjs/toolkit";
import { wrapLoading } from "./loading-animation.js";
export const perpToolSlice = createSlice({
    name: "perpTool",
    initialState: {
        pts: [[], [], [], []],
        toCrop: true,
    },
    reducers: {
        initState: (state, action) => {
            let w = action.payload.width,
                h = action.payload.height;
            let offX = 0.1 * w,
                offY = 0.1 * h;
            state.pts = [
                [offX, offY],
                [w - offX, offY],
                [w - offX, h - offY],
                [offX, h - offY],
            ];
        },
        updatePts: (state, action) => {
            let w = action.payload.width,
                h = action.payload.height;
            let idx = action.payload.idx;
            let newPt = action.payload.newPt;
            state.pts = state.pts.map((item, index) => {
                if (index === idx) return newPt;
                else return [item[0], item[1]];
            });
        },
        updateToCrop: (state, action) => {
            state.toCrop = action.payload.toCrop;
        },
    },
});

const { initState, updatePts, updateToCrop } = perpToolSlice.actions;

export class PerpToolCnvControls {
    /**@type {Context} */
    context;
    /**@type {import("redux").Store} */
    store;
    rad = 6;
    pts = [[], [], [], []];
    #dragInd = -1;
    listeners = {};
    static perpTool = null;

    static getInstance(context, store) {
        if (this.perpTool === null) {
            this.perpTool = new PerpToolCnvControls(context, store);
        }
        return this.perpTool;
    }
    constructor(context, store) {
        this.context = context;
        this.store = store;
        this.listeners = {
            mousedown: this.mDown,
            mousemove: this.mMove,
            mouseup: this.mUp,
            mouseleave: this.mLeave,
        };
    }
    getPts = () => {
        return this.store.getState().perpTool.pts;
    };
    initState = () => {
        let pts = this.getPts();
        if (pts[0].length === 0)
            this.store.dispatch(
                initState({
                    width: this.context.offScrCnv.width,
                    height: this.context.offScrCnv.height,
                })
            );
    };
    drawControls = () => {
        let tr = this.context.cnvCtx.getTransform();
        let pts = this.getPts();
        pts = pts.map(this.context.orToView.bind(this.context));
        this.context.cnvCtx.strokeStyle = "red";
        this.context.cnvCtx.lineWidth = 3;
        this.context.cnvCtx.setTransform(1, 0, 0, 1, 0, 0);
        for (let i = 0; i < pts.length; ++i) {
            let next = (i + 1) % pts.length;
            this.context.cnvCtx.beginPath();
            this.context.cnvCtx.moveTo(pts[i][0], pts[i][1]);
            this.context.cnvCtx.lineTo(pts[next][0], pts[next][1]);
            this.context.cnvCtx.stroke();
        }
        for (let i = 0; i < pts.length; ++i) {
            this.context.cnvCtx.beginPath();
            this.context.cnvCtx.arc(
                pts[i][0],
                pts[i][1],
                this.rad,
                2 * Math.PI,
                false
            );
            this.context.cnvCtx.fillStyle = "blue";
            this.context.cnvCtx.strokeStyle = "#000033";
            this.context.cnvCtx.fill();
            this.context.cnvCtx.lineWidth = 1;
            this.context.cnvCtx.stroke();
        }
        this.context.cnvCtx.setTransform(tr);
    };
    #checkClick = (point) => {
        let pts = this.getPts();
        pts = pts.map(this.context.orToView.bind(this.context));
        for (let i = 0; i < pts.length; ++i) {
            let lt = [pts[i][0] - this.rad, pts[i][1] - this.rad];
            let rb = [pts[i][0] + this.rad, pts[i][1] + this.rad];
            if (
                lt[0] < point[0] &&
                lt[1] < point[1] &&
                rb[0] > point[0] &&
                rb[1] > point[1]
            ) {
                return i;
            }
        }
        return -1;
    };
    updateImage = () => {
        this.context.updateImage();
        this.drawControls();
    };
    mDown = (event) => {
        this.drawControls();
        this.#dragInd = this.#checkClick([event.offsetX, event.offsetY]);
    };
    mMove = (event) => {
        if (this.#dragInd > -1) {
            let newPt = this.context.viewToOr([event.offsetX, event.offsetY]);
            this.store.dispatch(
                updatePts({
                    idx: this.#dragInd,
                    newPt: newPt,
                    width: this.context.offScrCnv.width,
                    height: this.context.offScrCnv.height,
                })
            );
            // this.pts[this.#dragInd] = [event.offsetX, event.offsetY];
            // this.#ptsDim = [this.context.cnv.width, this.context.cnv.height];
            // this.context.updateImage();
            // this.drawControls();
        }
    };
    mUp = (event) => {
        this.#dragInd = -1;
    };
    mLeave = (event) => {
        this.#dragInd = -1;
    };
}
export const PerpProps = (props) => {
    /**@type {Context} */
    const context = props.context;
    const args = props.args;
    const [changeAr, setChangeAr] = useState(true);
    const [arWidth, setArWidth] = useState(args.arW);
    const [arHeight, setArHeight] = useState(args.arH);
    const pts = useSelector((state) => state.perpTool.pts);
    const toCrop = useSelector((state) => state.perpTool.toCrop);

    const changeDiv = useRef();
    const dispatch = useDispatch();
    const onCheckChange = () => {
        setChangeAr(!changeAr);
        /**@type {HTMLDivElement} */
        let div = changeDiv.current;
        // It is reversed because setChangeAr is delayed operation.
        if (changeAr) div.classList.add("deactivated");
        else div.classList.remove("deactivated");
    };
    const solveTransform = (p, q) => {
        let A = [
            [
                p[0][0],
                p[0][1],
                1,
                0,
                0,
                0,
                -p[0][0] * q[0][0],
                -p[0][1] * q[0][0],
            ],
            [
                0,
                0,
                0,
                p[0][0],
                p[0][1],
                1,
                -p[0][0] * q[0][1],
                -p[0][1] * q[0][1],
            ],

            [
                p[1][0],
                p[1][1],
                1,
                0,
                0,
                0,
                -p[1][0] * q[1][0],
                -p[1][1] * q[1][0],
            ],
            [
                0,
                0,
                0,
                p[1][0],
                p[1][1],
                1,
                -p[1][0] * q[1][1],
                -p[1][1] * q[1][1],
            ],

            [
                p[2][0],
                p[2][1],
                1,
                0,
                0,
                0,
                -p[2][0] * q[2][0],
                -p[2][1] * q[2][0],
            ],
            [
                0,
                0,
                0,
                p[2][0],
                p[2][1],
                1,
                -p[2][0] * q[2][1],
                -p[2][1] * q[2][1],
            ],

            [
                p[3][0],
                p[3][1],
                1,
                0,
                0,
                0,
                -p[3][0] * q[3][0],
                -p[3][1] * q[3][0],
            ],
            [
                0,
                0,
                0,
                p[3][0],
                p[3][1],
                1,
                -p[3][0] * q[3][1],
                -p[3][1] * q[3][1],
            ],
        ];
        let b = [
            q[0][0],
            q[0][1],
            q[1][0],
            q[1][1],
            q[2][0],
            q[2][1],
            q[3][0],
            q[3][1],
        ];
        // let solution = math.lusolve(A,b);
        let solution = lusolve(A, b);

        return solution;
    };
    const handleToCropChange = (event) => {
        let newVal = event.target.checked;
        console.log("toCrop: " + newVal);
        dispatch(updateToCrop({ toCrop: newVal }));
    };
    const perpTrNN = (tr_matrix, width, height, offset = [0, 0]) => {
        // let old_array = imageData.data;
        let old_array = context.curCnvCtx.getImageData(
            0,
            0,
            context.curCnv.width,
            context.curCnv.height
        ).data;
        let new_data = new Uint8ClampedArray(width * height * 4);
        let x, y, z;
        let count = 0;

        for (let i = -offset[0]; i < width - offset[0]; ++i) {
            for (let j = -offset[1]; j < height - offset[1]; ++j) {
                z = tr_matrix[2][0] * i + tr_matrix[2][1] * j + tr_matrix[2][2];
                x =
                    (tr_matrix[0][0] * i +
                        tr_matrix[0][1] * j +
                        tr_matrix[0][2]) /
                    z;
                y =
                    (tr_matrix[1][0] * i +
                        tr_matrix[1][1] * j +
                        tr_matrix[1][2]) /
                    z;
                let new_x = Math.floor(x),
                    new_y = Math.floor(y);
                if (
                    new_x >= context.curCnv.width ||
                    new_y >= context.curCnv.height ||
                    new_x < 0 ||
                    new_y < 0
                ) {
                    count++;
                    continue;
                }
                let new_idx = (j + offset[1]) * width * 4 + (i + offset[0]) * 4;
                let old_idx = new_y * context.curCnv.width * 4 + new_x * 4;
                new_data[new_idx] = old_array[old_idx];
                new_data[new_idx + 1] = old_array[old_idx + 1];
                new_data[new_idx + 2] = old_array[old_idx + 2];
                new_data[new_idx + 3] = old_array[old_idx + 3];
            }
        }
        return new_data;
    };
    const getTrSize = () => {
        let newH, newW;
        if (!changeAr) {
            newH = context.offScrCnv.height;
            newW = context.offScrCnv.width;
        } else {
            let w = context.offScrCnv.width,
                h = context.offScrCnv.height;
            newH = Math.min(w, h);
            newW = Math.round((newH / arHeight) * arWidth);
        }
        return [newW, newH];
    };
    const getOuterRect = (points) => {
        let lt = [2 << 14, 2 << 14];
        let rb = [-2 << 14, -2 << 14];
        for (let p of points) {
            lt[0] = p[0] < lt[0] ? p[0] : lt[0];
            lt[1] = p[1] < lt[1] ? p[1] : lt[1];
            rb[0] = p[0] > rb[0] ? p[0] : rb[0];
            rb[1] = p[1] > rb[1] ? p[1] : rb[1];
        }
        return [lt, rb];
    };

    const fullPicTransform = () => {
        let maxSize = Math.pow(2, 14) - 1;
        let areaRect = getOuterRect(pts);
        console.log(`areaRect:`);
        console.log(areaRect);
        let newSize = [
            areaRect[1][0] - areaRect[0][0],
            areaRect[1][1] - areaRect[0][1],
        ];
        if (changeAr) {
            newSize[1] = Math.round((newSize[0] / arWidth) * arHeight);
            console.log(`newSize changed:`);
            console.log(newSize);
            console.log(`W/H: ${newSize[0] / newSize[1]}`);
        } else {
            console.log(`newSize:`);
            console.log(newSize);
            console.log(`W/H: ${newSize[0] / newSize[1]}`);
        }
        if (newSize[0] > maxSize || newSize[1] > maxSize) {
            // alert(`Результирующий размер изображения должен быть меньше ${maxSize}x${maxSize}`);
            return;
        }
        let finalPoints = [
            [0, 0],
            [newSize[0] - 1, 0],
            [newSize[0] - 1, newSize[1] - 1],
            [0, newSize[1] - 1],
        ];
        let tr = solveTransform(finalPoints, pts);
        let invTr = solveTransform(pts, finalPoints);
        let trMat = [
            [tr[0][0], tr[1][0], tr[2][0]],
            [tr[3][0], tr[4][0], tr[5][0]],
            [tr[6][0], tr[7][0], 1],
        ];
        let invTrMat = [
            [invTr[0][0], invTr[1][0], invTr[2][0]],
            [invTr[3][0], invTr[4][0], invTr[5][0]],
            [invTr[6][0], invTr[7][0], 1],
        ];

        let w = context.offScrCnv.width;
        let h = context.offScrCnv.height;
        let edgePts = [
            [0, 0],
            [w - 1, 0],
            [w - 1, h - 1],
            [0, h - 1],
        ];
        let newEdge = [];
        let z, x, y;
        for (let c = 0; c < edgePts.length; ++c) {
            let i = edgePts[c][0],
                j = edgePts[c][1];
            z = invTrMat[2][0] * i + invTrMat[2][1] * j + invTrMat[2][2];
            x = (invTrMat[0][0] * i + invTrMat[0][1] * j + invTrMat[0][2]) / z;
            y = (invTrMat[1][0] * i + invTrMat[1][1] * j + invTrMat[1][2]) / z;
            newEdge.push([Math.floor(x), Math.floor(y)]);
        }
        console.log(`newEdge:`);
        console.log(newEdge);
        let newRect = getOuterRect(newEdge);
        console.log(`newRect:`);
        console.log(newRect);
        let newCnvSize = [
            newRect[1][0] - newRect[0][0],
            newRect[1][1] - newRect[0][1],
        ];

        console.log(`newCnvSize:`);
        console.log(newCnvSize);
        // let k=1;
        // if (newCnvSize[0] > MAX_CANVAS_SIZE) {
        //     k = newCnvSize[0] / newCnvSize[1];
        //     newCnvSize[0] = MAX_CANVAS_SIZE;
        //     newCnvSize[1] = Math.round(newCnvSize[0] / k);
        // } else if (newCnvSize[1] > MAX_CANVAS_SIZE) {
        //     k = newCnvSize[0] / newCnvSize[1];
        //     newCnvSize[1] = MAX_CANVAS_SIZE;
        //     newCnvSize[0] = Math.round(newCnvSize[1] * k);
        // }
        // console.log(`clipped newCnvSize`);
        // console.log(newCnvSize);
        let offset = [-newRect[0][0], -newRect[0][1]];
        console.log(`offset:`);
        console.log(offset);
        let newArr = perpTrNN(trMat, newCnvSize[0], newCnvSize[1], offset);
        let newData = new ImageData(newCnvSize[0], newCnvSize[1]);
        newData.data.set(newArr);
        context.offScrCnv.width = newCnvSize[0];
        context.offScrCnv.height = newCnvSize[1];
        context.offScrCnvCtx.putImageData(newData, 0, 0);
        context.updateImage();
    };

    const makeTransform = () => {
        let newSize = getTrSize();
        let maxSize = Math.pow(2, 15) - 1;
        //https://developer.mozilla.org/en-US/docs/Web/HTML/Element/canvas#maximum_canvas_size
        if (newSize[0] > maxSize || newSize[1] > maxSize) {
            // alert(`Результирующий размер изображения должен быть меньше ${maxSize}x${maxSize}`);
            return;
        }
        let finalPoints = [
            [0, 0],
            [newSize[0] - 1, 0],
            [newSize[0] - 1, newSize[1] - 1],
            [0, newSize[1] - 1],
        ];
        // let trPts = convertPts();
        // let tr = this.#solveTransform(trPts,finalPoints);
        let tr = solveTransform(finalPoints, pts);
        let perpMat = [
            [tr[0][0], tr[1][0], tr[2][0]],
            [tr[3][0], tr[4][0], tr[5][0]],
            [tr[6][0], tr[7][0], 1],
        ];
        // let newArr = this.perpTrNN(perpMat,this.context.offScrCnv.width,this.context.offScrCnv.height);
        // let newData = new ImageData(this.context.offScrCnv.width,this.context.offScrCnv.height);
        let newArr = perpTrNN(perpMat, newSize[0], newSize[1]);
        let newData = new ImageData(newSize[0], newSize[1]);
        newData.data.set(newArr);
        context.offScrCnv.width = newSize[0];
        context.offScrCnv.height = newSize[1];
        context.offScrCnvCtx.putImageData(newData, 0, 0);
        context.updateImage();
    };
    const widthOldVal = useRef(args.arW);
    const heightOldVal = useRef(args.arH);
    const onWidthChange = (event) => {
        // let newVal = Number(event.target.value);
        // setArWidth(Math.round(newVal));
        setArWidth(event.target.value);

    };
    const onWidthBlur = (event) => {
        let newVal = Number(event.target.value);
        if (0 < newVal && !isNaN(newVal)){
            setArWidth(Math.round(newVal));
            widthOldVal.current = newVal
        }
        else{
            setArWidth(widthOldVal.current)
        }
    };
    const onHeightBlur = (event) => {
        let newVal = Number(event.target.value);
        if (0 < newVal && !isNaN(newVal)){
            setArHeight(Math.round(newVal));
            heightOldVal.current = newVal
        }
        else{
            setArHeight(heightOldVal.current)
        }
    };
    const onHeightChange = (event) => {
        setArHeight(event.target.value);
    };
    const applyHandle = () => {
        // wrapLoading(makeTransform);
        wrapLoading(() => {
            if (toCrop) makeTransform();
            else fullPicTransform();
            context.putToHistory();
        });
    };
    const resetHandle = () => {
        dispatch(
            initState({
                width: context.offScrCnv.width,
                height: context.offScrCnv.height,
            })
        );
    };
    const wRef = useRef(null);
    const hRef = useRef(null);
    const form = (
        <RB.Form>
            <RB.FormGroup className="toolprop">
                <RB.Form.Row>
                    <RB.Form.Check
                        onChange={onCheckChange}
                        type="switch"
                        checked={changeAr}
                        id="perp-ar-change"
                        label="Изменить соотношение сторон"
                    />
                </RB.Form.Row>
                <div
                    id="perp-change-section"
                    ref={changeDiv}
                    className="active"
                >
                    <RB.Form.Row>
                        <RB.Col>
                            <RB.Form.Label>Ширина:</RB.Form.Label>
                        </RB.Col>
                        <RB.Col md={7}>
                            <RB.Form.Control
                                onChange={onWidthChange}
                                onBlur={onWidthBlur}
                                value={arWidth}
                                type="number"
                                size="sm"
                                id="perp-change-width"
                            ></RB.Form.Control>
                        </RB.Col>
                    </RB.Form.Row>
                    <RB.Form.Row>
                        <RB.Col>
                            <RB.Form.Label>Высота:</RB.Form.Label>
                        </RB.Col>
                        <RB.Col md={7}>
                            <RB.Form.Control
                                onChange={onHeightChange}
                                onBlur={onHeightBlur}
                                value={arHeight}
                                type="number"
                                size="sm"
                                id="perp-change-height"
                            ></RB.Form.Control>
                        </RB.Col>
                    </RB.Form.Row>
                </div>
                <RB.Form.Row>
                    <RB.Form.Check
                        type="checkbox"
                        checked={toCrop}
                        label="Обрезать изображение"
                        onChange={handleToCropChange}
                    ></RB.Form.Check>
                </RB.Form.Row>
                <RB.Form.Row className="button-row">
                    <RB.Button id="perp-apply" onClick={applyHandle} size="sm">
                        Применить
                    </RB.Button>
                    <RB.Button id="perp-reset" onClick={resetHandle} size="sm">
                        Сброс
                    </RB.Button>
                </RB.Form.Row>
            </RB.FormGroup>
        </RB.Form>
    );
    return form;
};
